export const formatAmount = (amount) => {
  if (isNaN(amount)) return '₹0.00'
  return `₹${Number(amount).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}
